import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Playlist from './components/Playlist';
import AddPlaylist from './components/AddPlaylist';
// import BackButton from './components/BackButton';
import { ThemeProvider } from './theme/theme';

function App() {
  const [streamUrl, setStreamUrl] = React.useState('');
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <ThemeProvider>
      <Router>
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <main style={{ paddingTop: 60, paddingBottom: 80 }}>
          <Routes>
            <Route path="/" element={<Playlist onSelect={setStreamUrl} />} />
            <Route path="/add-playlist" element={<AddPlaylist />} />
          </Routes>
        </main>

        <Footer />
        {/* <BackButton /> */}
      </Router>
    </ThemeProvider>
  );
}

export default App;
